export const SWIPER_KINDS = {
  PROJECTS: 'projects',
  TESTIMONIALS: 'testimonials',
  CTOS: 'ctos',
}

export const SWIPER_SCROLLBAR_DATA = {
  el: 'scrollbar__container',
  dragClass: 'scrollbar__drag',
}
export const SWIPER_CLASS_MODIFIERS = {
  projects: '--projects',
  demo: '--demo',
}

export const SLIDE_WIDTH = {
  narrow: 340,
  medium: 510,
  wide: 780,
}

export const SLIDE_CONTAINER_WIDTH = [
  SLIDE_WIDTH.narrow,
  SLIDE_WIDTH.medium,
  SLIDE_WIDTH.medium,
  SLIDE_WIDTH.medium,
  SLIDE_WIDTH.medium,
  SLIDE_WIDTH.wide,
]
export const SLIDE_IMAGE_WIDTH = [300, 468, 468, 630]
export const SLIDE_IMAGE_HEIGHT = [165, 257, 257, 346]
export const SLIDE_SPACE_BETWEEN = { narrow: 32, medium: 64, wide: 120 }
export const SLIDE_NAV_WIDTH = [
  SLIDE_SPACE_BETWEEN.narrow,
  SLIDE_SPACE_BETWEEN.medium,
  SLIDE_SPACE_BETWEEN.medium,
  SLIDE_SPACE_BETWEEN.wide,
]
export const SLIDE_SPEED = 500

export const DEMO_SLIDE_WIDTH = 340

export const DEMO_SLIDE_CONTAINER_WIDTH = DEMO_SLIDE_WIDTH
export const DEMO_SLIDE_BETWEEN = SLIDE_SPACE_BETWEEN.narrow

export const DEMO_SLIDE_SPEED = SLIDE_SPEED
